/**
 * Catalogue PDF import review route. Kept free of imports so App.tsx can register the lazy route
 * without pulling the feature's presentation code into the main bundle.
 */
export const CATALOG_IMPORT_REVIEW_ROUTE = "/nine-setup/catalog-import/:importId";

/** Link to the review screen of one import. */
export const catalogImportReviewPath = (importId: string): string =>
  `/nine-setup/catalog-import/${encodeURIComponent(importId)}`;
